// extracted by mini-css-extract-plugin
export default {"OurPartnersSection":"ourPartners_OurPartnersSection__klNs0","OurPartnersSectionDiv":"ourPartners_OurPartnersSectionDiv__KUbgn"};